import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const BrokerCancelDialog = ({ show, onHide, reasonsHtml, onConfirm, tripInfo }) => {
    const [selectedReason, setSelectedReason] = useState("");

    useEffect(() => {
        if (show) {
            setSelectedReason("");
        }
    }, [show]);

    const handleConfirm = () => {
        // Here, onConfirm probably just needs to do nothing for now as per user instruction "press ok, or close the dialog... do this then i will let you know further".
        // But we'll pass the reason anyway.
        onConfirm(selectedReason, tripInfo);
        onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="md" centered>
            <Modal.Header closeButton className="activate_dialog_header_bgcolor user-select-none text-white">
                <Modal.Title>Broker Trip Cancel Reasons</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group>
                    <Form.Label>Please select a reason for cancellation:</Form.Label>
                    <Form.Select
                        value={selectedReason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                        dangerouslySetInnerHTML={{ __html: "<option value=''>Select Reason</option>" + reasonsHtml }}
                    >
                    </Form.Select>
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleConfirm} disabled={!selectedReason}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default BrokerCancelDialog;
